import { LOG_LEVEL } from '../config/environment.js';

const NO_OP = (message, ...optionalParams) => { };

class ConsoleLogger {
    constructor(options = {}) {
        if (ConsoleLogger.instance) {
            return ConsoleLogger.instance;
        }
        const { level } = options;

        this.error = console.error.bind(console);

        if (level === 'error') {
            this.warn = NO_OP;
            this.log = NO_OP;
            ConsoleLogger.instance = this;
            return;
        }

        this.warn = console.warn.bind(console);

        if (level === 'warn') {
            this.log = NO_OP;
            ConsoleLogger.instance = this;
            return;
        }

        this.log = console.log.bind(console);

        ConsoleLogger.instance = this;
    }

    static getInstance(options) {
        if (!ConsoleLogger.instance) {
            ConsoleLogger.instance = new ConsoleLogger(options);
        }
        return ConsoleLogger.instance;
    }

    setLogLevel(level) {
        this.constructor.getInstance({ level });
    }
}

const logger = ConsoleLogger.getInstance({ level: LOG_LEVEL });

export default logger;